export const COLORS = {
  primary: '#FF513C',
  darkGrey: '#495057',
  midGrey: '#999999',
  lightGrey: '#eaeaea'
};
